import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const HistoricalDistributionChart = ({ data, classOpt, load }) => {
  console.log("HIST DIST CHART data returned:", data);

  // Helper function to format month and year as "month year"
  const formatMonthYear = (month, year) => {
    const monthMapping = {
      jan: "Jan",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dec",
    };
    return `${monthMapping[month]} ${year}`;
  };

  const formattedData = data
    ? Array.isArray(data["annual-share-dist"])
      ? data["annual-share-dist"].flatMap((yearData) => {
          const { year_no, ...monthReturns } = yearData;
          // Filter out non-monthly keys
          return Object.keys(monthReturns)
            .filter(
              (key) =>
                ![
                  "q1_share_distribution_amount",
                  "q2_share_distribution_amount",
                  "q3_share_distribution_amount",
                  "q4_share_distribution_amount",
                  "ytd_share_distribution_amount",
                ].includes(key)
            )
            .map((key) => {
              const [month] = key.split("_"); // Extract the month from the key
              const value = parseFloat(monthReturns[key]); // Parse value as a number
              return {
                date: formatMonthYear(month, year_no), // Format date as "Month Year"
                value, // Numeric value for the chart
              };
            });
        })
      : Object.keys(data["annual-growth"]) // Handle the case where it's an object
          .filter(
            (key) =>
              ![
                "q1_share_distribution_amount",
                "q2_share_distribution_amount",
                "q3_share_distribution_amount",
                "q4_share_distribution_amount",
                "ytd_share_distribution_amount",
                "year_no",
              ].includes(key)
          )
          .map((key) => {
            const [month] = key.split("_"); // Extract the month from the key
            const value = parseFloat(data["annual-share-dist"][key]); // Parse value as a number
            const year_no = data["annual-share-dist"].year_no; // Extract year number
            return {
              date: formatMonthYear(month, year_no), // Format date as "Month Year"
              value, // Numeric value for the chart
            };
          })
    : null;

  // Only include valid data points
  const validData = formattedData
    ? formattedData.filter((entry) => !isNaN(entry.value) && entry.value > 0)
    : [];

  return (
    <div className="main-padding">
      <div className="main-margin">
        {/* <div className="monthly-total-return-img-wrapper">
          <h1 className="sub-header">
            Historical Distributions Per Share<sup className="small-sup">2</sup>
          </h1>
        </div> */}
        <div className="chart-wrapper w-full h-full p-4 shadow-lg">
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={validData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 30,
              }}
            >
              <CartesianGrid horizontal={true} vertical={false} />
              <XAxis dataKey="date" tick={{ angle: -45, dy: 20 }} />
              <YAxis
                // label={{
                //   value: "Distributions", // Text to display
                //   angle: -90, // Rotate the label for vertical alignment
                //   position: "insideLeft", // Position relative to the axis
                //   offset: -12,
                //   style: { textAnchor: "middle" }, // Optional: center the text
                // }}
                tickFormatter={(value) => `$${value.toFixed(2)}`} // Format the tick values with a $ sign
                domain={[0.02, 0.10]} // Start at 9.75 and end at 10.75
                ticks={[0.02, 0.04, 0.06, 0.08, 0.10]} // Set custom ticks at $0.25 intervals
                tickMargin={10}
              />
              <Tooltip
                formatter={(value) => [`$${value.toFixed(2)}`]}
                contentStyle={{
                  borderColor: "#c39f5c",
                  borderRadius: "4px",
                }}
              />
              {/* <Legend /> */}
              <Bar
                type="monotone"
                dataKey="value"
                stroke="#c39f5c"
                fill="#c39f5c"
                strokeWidth={1}
                barSize={7}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default HistoricalDistributionChart;
